import { Grid } from "@mui/material";
import CardSkeleton from "components/Skeletons/Card.Skeleton";
import Table from "components/Table";
import useDispatch from "hooks/useDispatch";
import WrapperAverageBuy from "pages/Portfolio/Components/PortfolioTradeTable/Components/WrapperAverageBuy";
import WrapperAverageSell from "pages/Portfolio/Components/PortfolioTradeTable/Components/WrapperAverageSell";
import WrapperMarketPrice from "pages/Portfolio/Components/PortfolioTradeTable/Components/WrapperMarketPrice";
import WrapperValueBalance from "pages/Portfolio/Components/PortfolioTradeTable/Components/WrapperValueBalance";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { getPortfolioTradeAvgForCoin } from "store/slices/portfolio/portfolioSlice";

const headers = [
  {
    key: "valueBalance",
    name: " Value Balance",
    align: "left",
  },
  {
    key: "averageBuy",
    align: "left",
    name: "Average Buy",
  },
  {
    key: "averageSell",
    align: "left",
    name: "Average Sell",
  },
  {
    key: "marketPrice",
    align: "left",
    name: " Market Price",
  },
];

export function TablePortfolioTradeCoin() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const walletType = +searchParams.get("walletType") || 0;
  const portfolioDate = +searchParams.get("portfolioDate") || 0;
  const { id } = useParams();

  const portfolioSingleTrade = useSelector(
    (state) => state.portfolio.portfolioSingleTrade?.data
  );

  useEffect(() => {
    dispatch(
      getPortfolioTradeAvgForCoin({
        coinId: id,
        dateTypeId: portfolioDate,
        walletTypeId: walletType,
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletType, portfolioDate, id]);

  const formattedDataList = [
    {
      data: portfolioSingleTrade,
      valueBalance: <WrapperValueBalance data={portfolioSingleTrade} />,
      averageBuy: <WrapperAverageBuy data={portfolioSingleTrade} />,
      averageSell: <WrapperAverageSell data={portfolioSingleTrade} />,
      marketPrice: <WrapperMarketPrice data={portfolioSingleTrade} />,
    },
  ];

  return (
    <Grid item xs={12} my={2}>
      {portfolioSingleTrade ? (
        <Table headers={headers} items={formattedDataList} hideBorders={true} />
      ) : (
        <CardSkeleton heightSize={172} />
      )}
    </Grid>
  );
}
export default TablePortfolioTradeCoin;
